<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ restaurant.title }}</strong>
                    <RestaurantTableOrderBadge />
                </CCardHeader>
                <CCardBody>
                    <RestaurantsTabLinks />
                    <CRow class="pl-3 pb-3" />
                    <CRow class="pl-3 pb-3">
                        <table class="table">
                            <thead>
                                <th>Название</th>
                                <th>Тип</th>
                                <th>Тип доставки</th>
                                <th>Учитывать при интеграции</th>
                                <th>Активный</th>
                            </thead>
                            <tr v-for="promotion in promotions" :key="promotion.title">
                                <td>
                                    <CLink :to="`/restaurants/${restaurant.id}/promotions/${promotion.id}`">{{ promotion.title }}</CLink>
                                </td>
                                <td>{{ promotionTypeTitle(promotion.type) }}</td>
                                <td class="w-2/12 py-2">
                                    {{ labelDeliveryType(promotion.delivery_type) }}
                                </td>
                                <td>
                                    <CBadge :color="getBadge(promotion.accounting_in_integration)">
                                        &nbsp;{{ promotion.accounting_in_integration ? "Да" : "Нет" }}&nbsp;
                                    </CBadge>
                                </td>
                                <td>
                                    <CBadge :color="getBadge(promotion.enabled)">
                                        &nbsp;{{ promotion.enabled ? "Да" : "Нет" }}&nbsp;
                                    </CBadge>
                                </td>
                            </tr>
                        </table>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="create">Создать</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import RestaurantsTabLinks from '@/components/RestaurantsTabLinks';
    import { promotionTypeTitle } from '../../utils/promotion-views';
    const { DELIVERY_TYPE } = require('../../utils/order');

    export default {

        name: 'RestaurantPromotions',
        components: {
            RestaurantsTabLinks,
        },

        data() {
            return {
                restaurant: {},
                promotions: [],
            };
        },

        computed: {},

        mounted() {
            const id = this.$route.params.id;
            Vue.axios
                .get('/restaurants/' + id)
                .then(resp => {
                    this.restaurant = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios
                .get('/promotions/restaurant/' + id)
                .then(resp => {
                    this.promotions = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {
            create() {
                this.$router.push(
                    '/restaurants/' + this.restaurant.id + '/promotions/create'
                );
            },

            getBadge(status) {
                return status ? 'success' : 'secondary';
            },

            promotionTypeTitle(type) {
                return promotionTypeTitle(type);
            },
            labelDeliveryType (delivery_type) {
                const types = [];
                types.push({ value: DELIVERY_TYPE.DOOR, label: 'До двери' });
                types.push({ value: DELIVERY_TYPE.MEETING_POINT, label: 'Место встречи' });
                types.push({ value: DELIVERY_TYPE.WITHOUT, label: 'Без доставки' });
                types.push({ value: DELIVERY_TYPE.COLLECT, label: 'Сборка заказа' });

                for (const type of types) {
                    if(delivery_type === type.value){
                        return type.label;
                    }
                }
                return '';
            },
        },
    };
</script>
<style scoped>
</style>
